// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".azati-vwc-input-checkbox label a{text-decoration:none;color:#ff9c42;transition:color .3s ease;text-decoration:underline}.azati-vwc-input-checkbox label a:focus,.azati-vwc-input-checkbox label a:hover,.azati-vwc-input-checkbox label a:visited{color:#f9823a}", ""]);
// Exports
module.exports = exports;
